import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  display: flex;
  z-index: 2;
  top: auto;
  bottom: 100%;
  right: 10px;
  left: auto;
  position: absolute;

  ${media.lg`
    bottom: 0;
    right: 10px;
    left: auto;
  `}
`

const Button = styled.button`
  width: 80px;
  height: 40px;
  background: ${props => props.theme.colors.theme.base};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border-left: 1px solid ${props => props.theme.colors.theme.light};

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    cursor: pointer;

    svg {
      transform: translateX(25%);
    }

    &:first-child svg {
      transform: translateX(-25%);
    }
  }
`

const StyledPath = styled.path`
  fill: ${props => props.active ? props.theme.colors.grey.lightest : props.theme.colors.theme.light};
  transition: fill 0.3s ${easing.easeOutCubic};
`

export default class Controls extends Component {
  render() {
    const {
      next,
      prev,
      activeTime,
      length,
    } = this.props

    return(
      <Wrapper>
      
        <Button onClick={prev}>
          <svg
            width="19"
            height="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <StyledPath
              active={activeTime > 0}
              fillRule="evenodd"
              d="M7.67693779.188776C7.83580011.0396635 7.95882491 5e-7 8.15994356 5e-7h.86197469c.36078327 0 .44315634.2424962.20085135.4699303L2.37751835 6.89507201H18.1746842c.2607587 0 .4011673.13179133.4011673.37654666v.51888126c0 .24475534-.1404086.37654667-.4011673.37654667H2.37751835l6.84525125 6.42514121c.24230499.22743412.15993192.46993027-.20111865.46993027h-.86197469c-.20111865 0-.3417945-.056482-.48273806-.1887755L.1357953 7.79501831c-.18106029-.16994817-.18106029-.35797061 0-.52791878L7.6769382.1887753l-4.1e-7 7e-7z"
            />
          </svg>
        </Button>
        
        <Button onClick={next}>
          <svg
            width="19"
            height="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <StyledPath
              active={activeTime < length - 1}
              fillRule="evenodd"
              d="M10.89891421 14.873342c-.15886232.1491125-.28188712.1887755-.48300577.1887755h-.86197469c-.36078327 0-.44315634-.2424962-.20085135-.4699303l6.84525125-6.4251412H.4011678c-.2607587 0-.4011673-.1317913-.4011673-.3765467v-.5188812c0-.2447554.1404086-.3765467.4011673-.3765467h15.79716585L9.3530824.4699302C9.11077741.2424961 9.19315048-1e-7 9.55420105-1e-7h.86197469c.20111865 0 .3417945.056482.48273806.1887755l7.5411429 7.0783243c.18106029.1699482.18106029.3579706 0 .5279188l-7.5411429 7.0783242 4.1e-7-7e-7z"
            />
          </svg>
        </Button>
      
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/Controls.js